import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { getIconByNameOrTranslation, SectionIcon } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/Attributes/components/SectionIcon.js';
import { Attributes } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/components/Attributes/index.js';
import { Section } from '../../../../../../components/HotelDetailsOverlay/components/AttributesSection/components/SupplierAttributes/components/Section.js';
import { Flex } from '../../../../../../primitives/index.js';
export const SupplierAttributes = ({
  data
}) => {
  const allTitlesHaveIcons = data.every(({
    name = ''
  }) => getIconByNameOrTranslation(name) !== null);
  return _jsx(Flex, {
    divider: true,
    spacing: "dividers/medium",
    children: data.map(({
      sub_sections: subSections,
      name,
      amenities
    }, index) => _jsxs(_Fragment, {
      children: [_jsxs(Flex, {
        direction: "row",
        spacing: "headlines/large",
        children: [allTitlesHaveIcons && name && _jsx(SectionIcon, {
          name: name
        }), _jsx(Text, {
          preset: "headlineMedium",
          children: name
        })]
      }), subSections?.length ? _jsx(Flex, {
        divider: true,
        spacing: "dividers/medium",
        children: subSections.map(({
          amenities: amenities2,
          name: name2
        }, index2) => _jsx(Section, {
          title: name2,
          amenities: amenities2
        }, index2))
      }) : _jsx(Attributes, {
        data: amenities
      }, index)]
    }))
  });
};